import React from 'react';

function WebFormPlusIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
            <mask id="mask0_1983_2465" maskUnits="userSpaceOnUse" x="2" y="6" width="44" height="37">
                <path
                    d="M25 40H7C6.20435 40 5.44129 39.6839 4.87868 39.1213C4.31607 38.5587 4 37.7956 4 37V11C4 10.2044 4.31607 9.44129 4.87868 8.87868C5.44129 8.31607 6.20435 8 7 8H41C41.7956 8 42.5587 8.31607 43.1213 8.87868C43.6839 9.44129 44 10.2044 44 11V24.941"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M4 11C4 10.2044 4.31607 9.44129 4.87868 8.87868C5.44129 8.31607 6.20435 8 7 8H41C41.7957 8 42.5587 8.31607 43.1213 8.87868C43.6839 9.44129 44 10.2044 44 11V20H4V11Z"
                    fill="white"
                    stroke="white"
                    stroke-width="4"
                />
                <path d="M32 35H44M38 29V41" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                <path
                    d="M8 14C8 12.8954 8.89543 12 10 12C11.1046 12 12 12.8954 12 14C12 15.1046 11.1046 16 10 16C8.89543 16 8 15.1046 8 14Z"
                    fill="black"
                />
                <path
                    d="M14 14C14 12.8954 14.8954 12 16 12C17.1046 12 18 12.8954 18 14C18 15.1046 17.1046 16 16 16C14.8954 16 14 15.1046 14 14Z"
                    fill="black"
                />
            </mask>
            <g mask="url(#mask0_1983_2465)">
                <path d="M0 0H48V48H0V0Z" fill="#FCB413" />
            </g>
        </svg>
    );
}

export default WebFormPlusIcon;
